// frontend/admin-portal/src/App.js
import React from 'react';
import { AppProviders } from './providers';
import { AppRoutes } from './routes';

export default function App() {
    return (
        <AppProviders>
            <AppRoutes />
        </AppProviders>
    );
}